import React from 'react';
import { SvgProps } from 'apps/sigma2-ui/src/components/svg/types';
import { toSvgColor } from 'apps/sigma2-ui/src/components/svg/types';

export const IconEditPaperGroup: React.FC<SvgProps> = (props) => {
  const fillColor = toSvgColor('currentColor', props);

  return (
    <g fill="none" {...(props.group ?? {})}>
      <path
        d="M8.75 3.74988H5C4.60218 3.74988 4.22064 3.90791 3.93934 4.18922C3.65804 4.47052 3.5 4.85205 3.5 5.24988V13.4999C3.5 13.8977 3.65804 14.2792 3.93934 14.5605C4.22064 14.8418 4.60218 14.9999 5 14.9999H13.25C13.6478 14.9999 14.0294 14.8418 14.3107 14.5605C14.592 14.2792 14.75 13.8977 14.75 13.4999V9.74988M13.6895 2.68938C13.8279 2.54611 13.9934 2.43184 14.1764 2.35323C14.3594 2.27461 14.5562 2.23323 14.7554 2.2315C14.9546 2.22977 15.1521 2.26772 15.3364 2.34315C15.5208 2.41857 15.6883 2.52995 15.8291 2.67079C15.9699 2.81162 16.0813 2.9791 16.1567 3.16345C16.2322 3.34779 16.2701 3.54531 16.2684 3.74448C16.2666 3.94365 16.2253 4.14048 16.1467 4.32348C16.068 4.50649 15.9538 4.67201 15.8105 4.81038L9.371 11.2499H7.25V9.12888L13.6895 2.68938Z"
        stroke={fillColor}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
  );
};
export const IconEditPaperSvg: React.FC<SvgProps> = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="19"
      height="18"
      viewBox="0 0 19 18"
      {...(props.svg ?? {})}
    >
      <IconEditPaperGroup {...props} />
    </svg>
  );
};
